var map = {
	"./heroshots/BusStopKiosk.webp": "563b",
	"./heroshots/FloorPiano.webp": "f7c8",
	"./heroshots/Kollapse.webp": "7886",
	"./heroshots/LetterOpener.webp": "9e61",
	"./heroshots/PigPushToy.webp": "bd6d",
	"./heroshots/Shi.webp": "8ddb",
	"./heroshots/Tetris.webp": "c4b2",
	"./heroshots/TwoSix.webp": "d6eb",
	"./heroshots/WateringCan.webp": "0870",
	"./my-things/my-things.webp": "2cd9",
	"./sketches/chair.webp": "35ce",
	"./sketches/fiftythree-pencil.webp": "a546",
	"./sketches/kollapse.webp": "8bd3",
	"./sketches/shoes.webp": "ac57",
	"./sketches/tape-measure.webp": "4c7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3448";